// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Yaa-z","narrowOptionButtons":"Zaa-z","noOptions":"_aa-z"};